import IndustryMarketplacesView from 'views/Industry/MarketplacesPage'

const Marketplaces = () => <IndustryMarketplacesView />

export default Marketplaces
